









































































import Vue from "vue";
import { Component } from "vue-property-decorator";
import ListViewItem from "list-view/src/listviewitem";
import NewsModel from "@views/a-model/news-model";
import DefaultModel from "@views/a-model/default-model";
import ControlValidatorGroupComponent from "../components/control-validator-group.vue";
import iMobileDeviceUser from "../a-model/interfaces/iMobileDeviceUser";
import iMarket from "../a-model/interfaces/iMarket";
import { EnumRoleType } from "../a-model/enum/EnumRoleType";
import { EnumTerminaleType } from "../a-model/enum/EnumTerminaleType";
import iHistory from "../a-model/interfaces/iHistory";
import iKpi from "../a-model/interfaces/iKpi";
import EnumKpiValueType from "../../dataSource/api/RunPay/Admin/IServices/Enums/EnumKpiValueType";

@Component({
  name: "kpi-user-history",
  components: {}
})
export default class KpiUserHistoryComponent extends Vue {
  currentRolleId: String = null;
  currentUserId: String = null;


  terminaleCode=""

  pageSize = 20;
  currentPage = 0;
  totalItems = 5;
  user:iMobileDeviceUser = null
  kpi:iKpi = null
  modalWindowShow = false;

  

  search = "";
  Items: iHistory[] = [];
  innerItems: iHistory[] = [];
  

  created() {
    document.title = this.$route.meta.title;
    // this.getRoles();
    // debugger
    this.getUser(this.$route.params.userId);
  }

  /*возвращаемся на страницу списка пользователей */
  goMobileDeviceUsers(){
    this.$router.push({ path: `/kpi-user/${this.$route.params.kpiId}` })
    // this.$router.push({ path: `devices/${userId}` });
  }


  /*получаем информацию о пользователе */
  getUser(userId:string){
    // debugger
    this.$api.UserMobileService.GetSingleUserEvent.once(response=>{
      if (!response) {
        return;
      }
      
      this.user={id:response.Value.UserId.toString(),name:response.Value.Name.toString(),email:response.Value.Email.toString(),dateCreate:new Date,role:response.Value.Role}
      
      this.getItems({ Take: this.pageSize, Skip: this.currentPage });
    })
    this.$api.UserMobileService.GetSingleUser(parseInt(userId))
  }

 /**Получаем информацию о текущем KPI */
  getKpi(){
    this.$api.KpiService.GetSingleKpiEvent.once(response=>{
      if (!response.IsSuccess) {
        return;
      }
      var item = response.Value
      this.kpi={
        id:item.Id,
        target:item.GoalDescription,
        fromDate:item.DateStart,
        toDate: item.DateEnd,
        reward:0
      };
      // this.getItems({ Take: this.pageSize, Skip: this.currentPage });
    })
    this.$api.KpiService.GetSingleKpi(parseInt(this.$route.params.kpiId))
  }

  getItems({ Skip, Take }: { Skip: number; Take: number }) {
    this.$api.KpiService.GetPaginatedClientHistoryListEvent.once(response=>{
      if (!response.IsSuccess) {
        return                      
      }
    this.innerItems=[]
    this.totalItems = response.Value.Count
    this.innerItems = response.Value.Items.map(item=>({
      id:item.Id,
      connectionDate:item.Date
    }))

    })
    this.$api.KpiService.GetPaginatedClientHistoryList({UserId:parseInt(this.user.id),Id:parseInt(this.$route.params.kpiId),Skip:this.currentPage,Take:this.pageSize})
  }

  /**
   *     id             : string;
    connectionDate : Date;
    shopName       : string;
    deviceCode     : string;
   */


  isValid(): boolean {
    return ((this.$refs.validator as ControlValidatorGroupComponent).isValid());
  }


  onPaginationChanged(request: { Page: number; CountOnPage: number }) {
    this.getItems({
      Skip: (request.Page - 1) * request.CountOnPage,
      Take: request.CountOnPage
    });
  }

  onShowWindowAddDevice() {
    
    this.modalWindowShow = true;
  }



  closeModalWindow() {
    this.modalWindowShow = false;

  }

  /**
   * Сортировка таблицы по имени полю и направлению(0,1)
   */
  onSort(sortName: string, sortType: string) {
    // console.log("sortName",sortName," sortType:",sortType)
    switch (sortName) {
      case "id":
        if (sortType == "1") {
          this.innerItems.sort(function(a, b) {
            return a.id > b.id ? 1 : -1;
          });
          break;
        } else {
          this.innerItems.sort(function(a, b) {
            return a.id < b.id ? 1 : -1;
          });
          break;
        }
      case "shopName":
        if (sortType == "1") {
          this.innerItems.sort(function(a, b) {
            return a.shopName > b.shopName ? 1 : -1;
          });
          break;
        } else {
          this.innerItems.sort(function(a, b) {
            return a.shopName < b.shopName ? 1 : -1;
          });
          break;
        }
      case "deviceCode":
        if (sortType == "1") {
          this.innerItems.sort(function(a, b) {
            return a.deviceCode > b.deviceCode ? 1 : -1;
          });
          break;
        } else {
          this.innerItems.sort(function(a, b) {
            return a.deviceCode < b.deviceCode ? 1 : -1;
          });
          break;
        }
      case "connectionDate":
        if (sortType == "1") {
          this.innerItems.sort(function(a, b) {
            return a.connectionDate > b.connectionDate ? 1 : -1;
          });
          break;
        } else {
          this.innerItems.sort(function(a, b) {
            return a.connectionDate < b.connectionDate ? 1 : -1;
          });
          break;
        }
  
      default:
        break;
    }
  }
 async onDisconnectDeviceFromUser(deviceId:string){
  var res = await this.$dialog
        .confirm(this.$locale('Dialog_reallyDelete'))
        .then((res: boolean) => {
          if (res) {
            // this.$api.NewsService.DeleteEvent.once(response => {
            //   if (!response.IsSuccess) {
            //     return;
            //   }
            //   this.getNews({ Take: this.pageSize, Skip: this.currentPage });
            // });
            // this.$api.NewsService.Delete(parseInt(newsId));
          }
          if (res == false) {
          }
        });
    }

  // onCreate() {
  //   this.$api.NewsService.SaveEvent.once(response=>{
  //     if (!response.IsSuccess) {
  //       return
  //     }
  //     this.editImage = false;
  //     this.getNews({ Take: this.pageSize, Skip: this.currentPage });
  //   })

  //   this.addingNews.type = this.getNewsType(
  //     this.newsCategories.filter(item => item.Selected)[0].Value.id
  //   );
  //   this.addingNews.image = this.file.substring(this.file.indexOf(",") + 1);
  //   this.addingNews.zipArchiveFile = this.fileZip.substring(
  //     this.fileZip.indexOf(",") + 1
  //   );
  //   this.$api.NewsService.Save({
  //     Name:           this.addingNews.name,
  //     Description:    this.addingNews.description,
  //     FolderName:     this.addingNews.folderName,
  //     Type:           this.addingNews.type,
  //     Image:          this.addingNews.image,
  //     ZipArchiveFile: this.addingNews.zipArchiveFile
  //   });
  //   this.modalWindowShow = false;

  // }

   onConnectDeviceToUser(){
        // проверяем есть ли такой код и если есть подкючаем
     if (!false){ this.$dialog.success(this.$locale.getTranslate('deviceNotFound'))}
    }
        
    
  //   onOperation() {
  //     if (!this.isValid()) {
  //       return;
  //     }
  //     this.$api.NewsService.SaveEvent.once(response=>{
  //       if (!response.IsSuccess) {
  //         return
  //       }
  //       this.getNews({ Take: this.pageSize, Skip: this.currentPage });
  //     })
  //     this.addingNews.type = this.getNewsType(
  //       this.newsCategories.filter(item => item.Selected)[0].Value.id
  //     );
  //     this.addingNews.image = this.file?this.file.substring(this.file.indexOf(",") + 1):null;
  //     this.addingNews.zipArchiveFile = this.fileZip?this.fileZip.substring(this.fileZip.indexOf(",") + 1):null;
  //     this.$api.NewsService.Save({
  //       Id:             this.addingNews.id,
  //       Name:           this.addingNews.name,
  //       Description:    this.addingNews.description,
  //       FolderName:     this.addingNews.folderName,
  //       Type:           this.addingNews.type,
  //       Image:          this.addingNews.image,
  //       ZipArchiveFile: this.addingNews.zipArchiveFile
  //     });
  //     this.closeModalWindow();
  //   }

  //   getCurrentCategory(): DefaultModel {
  //     const category = this.newsCategories.filter(el => el.Selected);
  //     return category.length > 0 ? (category[0].Value as DefaultModel) : null;
  //   }
}



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./scripts/views/pages/page-kpi-user-history.vue